
































































































































































import { Component, Vue } from "vue-property-decorator";
import { storeScEmergency } from "@/store/modules/ScEmergencyStore";

@Component
export default class ScEmergencyDashboard extends Vue {
  storeModule = storeScEmergency;

  get dash() {
    return this.storeModule.dashboard || {};
  }

  get bulanIni() {
    return this.dash.bulan_ini || {};
  }

  get trend() {
    return this.dash.trend_12_bulan || [];
  }

  get topAlasan() {
    return this.dash.top_alasan_tidak_tercapai || [];
  }

  get statusColor() {
    return this.bulanIni.status_target === "tercapai" ? "green" : "red";
  }

  mounted() {
    this.storeModule.loadDashboard();
  }
}
